import React, { Component } from 'react';
import PropTypes from 'prop-types'
// import ProfileToolTip from './ProfileToolTip';
import ProfileCompletion from './ProfileCompletion';

class ProfileCompletionSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onHover: false
        }
    }

    handleHover = () => {
        this.setState({ onHover: !this.state.onHover });
    };

    render() {
        const { sections, ...profileComplete } = this.props.profileComplete;
        let nonComplete = [];
        sections ? nonComplete = sections.filter((section) => !section.complete) : null;

        let completeness = `${profileComplete.currentPercentageComplete}%`;
        let unCompleteness = `${100 - profileComplete.currentPercentageComplete}%`;

        nonComplete.length === 0 ? completeness = `100%` : null;
        nonComplete.length === 0 ? unCompleteness = `0%` : null;

        return (
            <section className="container has-padding-0">
                            <div className='profile-completion'>
                                <div className="profile-completion__container">
                                    <div className="row">
                                        <div className="col-12 profile-complete__col">
                                            <div className="profile-completion__mouse-area" onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
                                                <p className="p-tag profile-completion__heading">{`Your profile is ${nonComplete.length === 0 ? 100 : profileComplete.currentPercentageComplete}% complete`}</p>
                                                <div className="profile-completion__progressBar">
                                                    <span className="completed" style={{ width:`${completeness}`}}></span><span className="incomplete" style={{ width: `${unCompleteness}`}}></span>    
                                                    </div>
                                            </div>
                                         </div>
                                     </div>
                                     {/* {this.state.onHover && <ProfileToolTip content={sections} />} */}
                                    {<ProfileCompletion content={sections} />}
                                 </div>
                             </div>
                         </section>
        );
    }
}

ProfileCompletionSection.propTypes = {
    profileComplete: PropTypes.object,
    sections: PropTypes.array
};

export default ProfileCompletionSection;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/ProfileCompletionSection.js